var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMaterialContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.886,
    height: 17.237,
    viewBox: "0 0 14.886 17.237",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-content-copy",
    "data-name": "Icon material-content-copy",
    d: "M13.969,1.5h-9.4A1.572,1.572,0,0,0,3,3.067V14.036H4.567V3.067h9.4Zm2.35,3.134H7.7A1.572,1.572,0,0,0,6.134,6.2V17.17A1.572,1.572,0,0,0,7.7,18.737h8.618a1.572,1.572,0,0,0,1.567-1.567V6.2A1.572,1.572,0,0,0,16.319,4.634Zm0,12.536H7.7V6.2h8.618Z",
    transform: "translate(-3 -1.5)",
    fill: "#676767"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMaterialContent);
export default __webpack_public_path__ + "static/media/Icon-material-content.ab8430703f8672550e5fa457d8517cf6.svg";
export { ForwardRef as ReactComponent };